import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

/**
 * Estado vazio padrao das listagens. Existe como componente porque a diferenca
 * entre "nao ha nada" e "a busca nao achou nada" precisa ser dita com as mesmas
 * palavras em toda tela: sem isso, cada lista inventa a propria frase e o
 * administrador nao sabe se filtrou demais ou se o cadastro esta vazio.
 */
export function EmptyState({ icon: Icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn("flex flex-col items-center gap-3 px-4 py-12 text-center", className)}>
      <div className="rounded-full bg-muted-foreground/10 p-3">
        <Icon className="size-6 text-muted-foreground" />
      </div>
      <div className="space-y-1">
        <p className="text-medium font-bold">{title}</p>
        {description ? (
          <p className="mx-auto max-w-sm text-small text-muted-foreground">{description}</p>
        ) : null}
      </div>
      {action}
    </div>
  );
}
